export default __webpack_public_path__ + "static/media/sixteen.a9b0bc63.jpeg";